/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiUserForOrganizationAdminRequest } from '../../models/api-user-for-organization-admin-request';
import { KeyType } from '../../models/key-type';

export interface PutApiKeyForOrganizationWithRoles$Params {
  organizationKey: KeyType;
  userKey: KeyType;
      body: ApiUserForOrganizationAdminRequest
}

export function putApiKeyForOrganizationWithRoles(http: HttpClient, rootUrl: string, params: PutApiKeyForOrganizationWithRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, putApiKeyForOrganizationWithRoles.PATH, 'put');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
    rb.path('userKey', params.userKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

putApiKeyForOrganizationWithRoles.PATH = '/administration/organizations/{organizationKey}/api-users-keys/{userKey}';
